import classNames from "classnames";


import { ClockIcon } from "../../AscIcons";

import styles from "./AscMainChallengeCard.module.scss";
import AscAdminDropdown from "../../AscAdminDropdown/AscAdminDropdown";
import AscHeading from "../../AscTypography/AscHeading/AscHeading";
import AscParagraph from "../../AscTypography/AscParagraph/AscParagraph";
import { pluralizeIfNecessary } from "@ascendnow/shared";
import AscGenericCard from "../AscGenericCard/AscGenericCard";

export interface AscMainChallengeCardProps {
  id: string;
  title: string;
  points: number;
  daysNum: number;
  price: number;
  thumbnail: {
    key: string;
    bucket: string;
    location: string;
  };
  onEdit?: () => void;
  onDelete?: () => void;
}

export default function AscMainChallengeCard({
  title,
  thumbnail,
  daysNum,
  points,
  price,
  onEdit,
  onDelete,
}: AscMainChallengeCardProps) {
  return (
    <AscGenericCard
      className={classNames(styles.ground)}
      imageClassName={styles.cardImage}
      bodyClassName={styles.cardBody}
      title={null}
      coverImageUrl={thumbnail.location}
      tags={[
        price
          ? {
              label: `${price} ${pluralizeIfNecessary("coin", price)}`,
              type: "card-brand-red",
            }
          : undefined,
        points
          ? {
              label: `${points} ${pluralizeIfNecessary("point", points)}`,
              type: "card-light-green",
            }
          : undefined,
      ]}
      tagsContainerClassName={styles.tagsContainer}
    >
      <div className={styles.content}>
        <div className={styles.leftField}>
          <AscHeading className={styles.title}>{title}</AscHeading>

          <span>
            <ClockIcon className={styles.clockIcon} />
            <AscParagraph className={styles.text}>{daysNum} days</AscParagraph>
          </span>
        </div>

        <AscAdminDropdown alignment="right" className={styles.dropdown}>
          <AscAdminDropdown.Option onClick={onEdit}>
            Edit
          </AscAdminDropdown.Option>
          <AscAdminDropdown.Option onClick={onDelete}>
            Delete
          </AscAdminDropdown.Option>
        </AscAdminDropdown>
      </div>
    </AscGenericCard>
  );
}
